import apiClient from '../client';
import type {
  FinancialReport, ProjectAnalyticsReport, FarmFinancialSummaryReport, CropPerformanceReport,
  SeasonComparisonReport, WarningsReport, LaborCostReport,
} from '../../types';

const reportService = {
  getFinancialReport: async (startDate: string, endDate: string) => {
    const response = await apiClient.get<FinancialReport>(
      `/reports/financial?startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  },

  getProjectAnalytics: async (projectId: string, startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
    if (startDate) params.set('startDate', startDate);
    if (endDate) params.set('endDate', endDate);
    const qs = params.toString();
    const response = await apiClient.get<ProjectAnalyticsReport>(`/reports/project/${projectId}${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  getFarmFinancialSummary: async (params?: { projectId?: string; operationId?: string }) => {
    const qs = new URLSearchParams();
    if (params?.projectId) qs.set('projectId', params.projectId);
    if (params?.operationId) qs.set('operationId', params.operationId);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    const response = await apiClient.get<FarmFinancialSummaryReport>(`/reports/farm-financial-summary${suffix}`);
    return response.data;
  },

  getCropPerformance: async (params?: { projectId?: string; operationId?: string; seasonId?: string }) => {
    const qs = new URLSearchParams();
    if (params?.projectId) qs.set('projectId', params.projectId);
    if (params?.operationId) qs.set('operationId', params.operationId);
    if (params?.seasonId) qs.set('seasonId', params.seasonId);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    const response = await apiClient.get<CropPerformanceReport>(`/reports/crop-performance${suffix}`);
    return response.data;
  },

  getSeasonComparison: async (params?: { projectId?: string; operationId?: string }) => {
    const qs = new URLSearchParams();
    if (params?.projectId) qs.set('projectId', params.projectId);
    if (params?.operationId) qs.set('operationId', params.operationId);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    const response = await apiClient.get<SeasonComparisonReport>(`/reports/season-comparison${suffix}`);
    return response.data;
  },

  getWarnings: async () => {
    const response = await apiClient.get<WarningsReport>('/reports/warnings');
    return response.data;
  },

  getLaborCost: async (params?: { projectId?: string }) => {
    const qs = new URLSearchParams();
    if (params?.projectId) qs.set('projectId', params.projectId);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    const response = await apiClient.get<LaborCostReport>(`/reports/labor-cost${suffix}`);
    return response.data;
  },
};

export default reportService;
